import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true
      });
      setUser(response.data);
      localStorage.setItem('user', JSON.stringify(response.data));
      
      // Notify TenantContext about auth state change
      window.dispatchEvent(new CustomEvent('auth-state-changed', { detail: response.data }));
    } catch (error) {
      console.error("Auth check failed:", error);
      setUser(null);
      localStorage.removeItem('user');
      
      // Notify TenantContext about logout
      window.dispatchEvent(new CustomEvent('auth-state-changed', { detail: null }));
    } finally {
      setLoading(false);
    }
  };

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    
    // Notify TenantContext to fetch tenant info after login
    window.dispatchEvent(new CustomEvent('auth-state-changed', { detail: userData }));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    
    // Notify TenantContext to clear tenant info
    window.dispatchEvent(new CustomEvent('auth-state-changed', { detail: null }));
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
